module.exports = __webpack_public_path__ + "img/1-sm.3385d1ef.jpg";